// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"27f06738","667":"7ddc6dd7"}[chunkId] + ".chunk.js";
};